import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type {
  AppNotification,
  LaravelResourcePage,
  NotificationListParams,
  NotificationPreferences,
  NotificationPreferencesPatch,
} from '@/types/notifications'

export const notificationsApi = {
  list: async (params: NotificationListParams = {}): Promise<LaravelResourcePage<AppNotification>> => {
    const response = await apiClient.get<LaravelResourcePage<AppNotification>>(
      API_ENDPOINTS.NOTIFICATIONS.LIST,
      { params },
    )
    return response.data
  },

  markRead: async (id: string): Promise<AppNotification> => {
    const response = await apiClient.post<{ data: AppNotification }>(
      API_ENDPOINTS.NOTIFICATIONS.READ(id),
    )
    return response.data.data
  },

  markAllRead: async (): Promise<void> => {
    await apiClient.post(API_ENDPOINTS.NOTIFICATIONS.MARK_ALL_READ)
  },

  getPreferences: async (): Promise<NotificationPreferences> => {
    const response = await apiClient.get<{ data: NotificationPreferences }>(
      API_ENDPOINTS.NOTIFICATIONS.PREFERENCES,
    )
    return response.data.data
  },

  updatePreferences: async (
    payload: NotificationPreferencesPatch,
  ): Promise<NotificationPreferences> => {
    const response = await apiClient.patch<{ data: NotificationPreferences }>(
      API_ENDPOINTS.NOTIFICATIONS.PREFERENCES,
      payload,
    )
    return response.data.data
  },
}
